import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";

export const Route = createFileRoute("/termos-de-servico")({
  head: () => ({
    meta: [
      { title: "Termos de serviço — Viny Club" },
      {
        name: "description",
        content: "Leia os termos de uso da Viny Club antes de utilizar nossos serviços.",
      },
    ],
  }),
  component: TermosDeServico,
});

function TermosDeServico() {
  return (
    <AppShell>
      <PageHeader
        eyebrow="Regras"
        title="Termos de serviço"
        subtitle="O que esperar de nós e o que esperamos de você."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 lg:px-8">
        <article className="space-y-8 text-foreground/90">
          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">1. Aceitação dos termos</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Ao criar uma conta na Viny Club, você concorda com estes Termos de Serviço. Se não concordar com qualquer parte, não utilize a plataforma. Reservamo-nos o direito de atualizar estes termos a qualquer momento, com aviso prévio.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">2. Uso permitido</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              A plataforma destina-se a colecionadores de vinil e entusiastas da música. É proibido o uso para spam, assédio, venda de produtos falsificados, conteúdo ilegal ou qualquer atividade que prejudique outros usuários ou a integridade do serviço.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">3. Contas e segurança</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Você é responsável por manter a confidencialidade de suas credenciais. Notifique-nos imediatamente sobre qualquer uso não autorizado da sua conta. Não nos responsabilizamos por perdas resultantes de negligência na proteção de login.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">4. Conteúdo do usuário</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Você mantém os direitos sobre o conteúdo que publica — avaliações, fotos, listas de discos. Ao publicar, concede à Viny Club uma licença não exclusiva para exibir esse conteúdo na plataforma. Não publicamos seu conteúdo fora da plataforma sem autorização.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">5. Planos, limites e recursos Pro</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              A Viny Club oferece um plano gratuito e um plano pago (Pro). Contas gratuitas criadas a partir de 19 de agosto de 2026 têm acesso limitado: não podem acessar a página de Insights e não podem anunciar discos para venda ou troca no Canal de Garimpo. Esses recursos são disponibilizados exclusivamente aos assinantes Pro.
            </p>

            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Contas criadas antes dessa data, bem como usuários que já tenham cadastrado mais de 30 discos na coleção, são consideradas legadas e permanecem com acesso ilimitado às funcionalidades gratuitas, mesmo sem assinatura Pro. A qualquer momento, um usuário pode optar por assinar o Pro para remover as limitações e acessar benefícios extras.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">6. Encerramento</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Podemos suspender ou encerrar contas que violem estes termos. Você pode excluir sua conta a qualquer momento nas configurações. A exclusão remove seus dados pessoais, mas avaliações e interações públicas podem permanecer anonimizadas.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">7. Limitação de responsabilidade</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              A Viny Club é fornecida "no estado em que se encontera". Não garantimos disponibilidade ininterrupta. Nosso responsabilidade por danos diretos é limitada ao valor pago pelos serviços nos últimos 12 meses.
            </p>
          </section>

          <p className="text-xs text-muted-foreground">
            Última atualização: {new Date().getFullYear()}.
          </p>
        </article>
      </div>
    </AppShell>
  );
}
